import Skeleton from 'react-loading-skeleton'

import Box from '@ilg-totallymoney/ui/components/Box'
import Divider from '@ilg-totallymoney/ui/components/Divider'
import Flex from '@ilg-totallymoney/ui/components/Flex'
import Grid from '@ilg-totallymoney/ui/components/Grid'
import Row from '@ilg-totallymoney/ui/components/Row'
import Stack from '@ilg-totallymoney/ui/components/Stack'
import theme from '@ilg-totallymoney/ui/theme'
import styled from 'styled-components'

import UnscoredTableItemCard from '../UnscoredTable/components/UnscoredTableItem/components/UnscoredTableItemCard'

const StyledSkeleton = styled(({ maxWidth, ...props }) => (
    <Skeleton maxWidth={maxWidth} {...props} />
))`
    border-radius: ${theme.radii.borderRadius10};
    max-width: ${props => props.maxWidth ?? 'unset'};
    width: 100%;
`

const SkeletonCategoryNavigation = styled(StyledSkeleton)`
    margin-right: ${theme.space10};
`

export const SkeletonUnscoredTableItem = () => (
    <UnscoredTableItemCard id="skeleton">
        <Stack space="space20" mb="space30" display={['flex', 'flex', 'grid']}>
            <Stack space="space20" gridColumn="1/13" gridRow={1}>
                {/* UnscoredTableItemBadgeSection */}
                <Row space="space10" width="100%" flexWrap="wrap">
                    <StyledSkeleton height="24px" width="130px" />
                    <StyledSkeleton height="24px" width="130px" />
                    <StyledSkeleton height="24px" width="130px" />
                </Row>

                {/* UnscoredTableTitleSection */}
                <Row space="space20" gridColumn="1/13" gridRow={1}>
                    <Box>
                        <Box display={['block', 'none']}>
                            <StyledSkeleton height="52px" width="107px" />
                        </Box>

                        <Box display={['none', 'block']}>
                            <StyledSkeleton height="86px" width="172px" />
                        </Box>
                    </Box>

                    <Stack space="space10" flexGrow={1}>
                        <StyledSkeleton
                            width="100%"
                            maxWidth="500px"
                            height="24px"
                            count={2}
                        />
                    </Stack>
                </Row>
            </Stack>

            {/* UnscoredTableItemProductInfoSection */}
            <Box gridColumn="1/12" gridRow={2}>
                <Row
                    display="grid"
                    gridTemplateColumns={[
                        'repeat(2, minmax(110px, 1fr))',
                        'repeat(auto-fill, minmax(160px, 170px))',
                        'repeat(auto-fill, 170px)',
                    ]}
                    flexWrap="wrap"
                    space="space05"
                >
                    <StyledSkeleton height="72px" />
                    <StyledSkeleton height="72px" />
                    <StyledSkeleton height="72px" />
                    <StyledSkeleton height="72px" />
                </Row>
            </Box>

            {/* UnscoredTableItemOffersSection */}
            <Box gridColumn="1/13" gridRow={3}>
                <Box mb="space20" width="100%" display={['none', 'block']}>
                    <Divider borderStyle="dashed" color="grey30" spacing={0} />
                </Box>

                <StyledSkeleton width="100%" height="32px" />
            </Box>

            {/* Button */}
            <Flex
                gridColumn="12/13"
                gridRow={2}
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
            >
                <Box maxWidth="280px" width={['100%', '100%', '212px']}>
                    <StyledSkeleton
                        borderRadius={theme.radii.borderRadius30}
                        height="48px"
                    />
                </Box>
            </Flex>
        </Stack>

        {/* Rep example */}
        <Box
            backgroundColor="grey10"
            m={['-space20', '-space30']}
            mt={[0, 'space30']}
            p="space30"
            pt="space15"
        >
            <StyledSkeleton maxWidth="300px" />

            <StyledSkeleton count={2} />
        </Box>
    </UnscoredTableItemCard>
)

const UnscoredTableSkeleton = () => (
    <Box py="space20">
        <Box mb="space30">
            <Grid>
                <Stack gridColumn="1/13" space="space30">
                    <Box
                        overflowY="hidden"
                        overflowX="scroll"
                        height={38}
                        width="100%"
                    >
                        <SkeletonCategoryNavigation
                            count={6}
                            inline={true}
                            height={38}
                            width={120}
                        />
                    </Box>

                    {/* Filter bar */}
                    <StyledSkeleton width="100%" height="50px" />
                </Stack>
            </Grid>
        </Box>

        <Grid>
            <Stack space="space20" gridColumn="1/13">
                <SkeletonUnscoredTableItem />
                <SkeletonUnscoredTableItem />
                <SkeletonUnscoredTableItem />
            </Stack>
        </Grid>
    </Box>
)

export default UnscoredTableSkeleton
